import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=737332e6&scoped=true&"
import script from "./PerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=737332e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737332e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VSkeletonLoader,VSpacer})
